<template>
  <div class="bind">
    <div class="toast">请先完善个人资料并绑定微信</div>
    <common-input
      v-model="bindData.phone"
      :err-msg="phonErrMsg"
      display="false"
      type="tel"
      name="手机号"
      :max="11"
      placeholder="请输入手机号"
      @inputBlured="checkPhone"
      @inputChanged="checkPhone"
    />
    <div class="van-cell hasinput">
      <span :class="codeFlag?'':'active'" class="get-code" @click="GetCode">{{ btnName }}</span>
      <input
        v-model="bindData.smsCode"
        class="van-field__control code_input"
        placeholder="请输入验证码"
        type="number"
        @blur="checkCode"
        @input="checkCode"
      >
      <div v-show="codeErrMsg" class="errMsg">
        <svg-icon icon-class="err" />
        {{ codeErrMsg }}
      </div>
    </div>
    <p class="bind_toast">
      *绑定微信即代表您已经同意
      <span>
        <router-link :to="'guide'">《康塔科技隐私保护指引》</router-link>
      </span>
    </p>
    <van-button class="sub_btn" type="info" :disabled="btnShow" @click="OnBind">绑定微信</van-button>
    <van-dialog v-model="visible" :before-close="beforeClose" title="请输入计算结果" show-cancel-button>
      <div style="display: flex; padding: 15px 20px">
        <img :src="captchaInfo.captcha" alt="" @click="getImg">
        <van-icon name="replay" color="#3b86ff" @click="getImg" />
        <input
          v-model="bindData.captchaResult"
          class="van-field__control code_input"
          placeholder="请输入计算结果"
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import commonInput from '@/components/commonInput';
import { onBind, getCode, inviteInfo } from '@/api/home';
import config from '@/common/config';
import { GetUserInfo, getCaptcha } from '@/api/user';
import { Toast } from 'vant';
export default {
  name: 'Bind',
  components: {
    commonInput
  },
  data() {
    return {
      bindData: {
        name: '',
        faceImg: '',
        gender: 'MALE',
        phone: '',
        smsCode: '',
        company: '',
        captchaResult: null
      },
      captchaInfo: {
        open: false
      },
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      btnName: '获取验证码',
      btnDefault: '重发验证码',
      countDown: 60,
      codeInterval: null,
      nameErrMsg: '', // 姓名输入提示
      phonErrMsg: '', // 手机号校验提示
      imgErr: false, // 人脸识别失败提示
      codeErrMsg: '', // 验证码校验失败提示
      show: false,
      codeFlag: true,
      btnShow: true,
      visible: false
    };
  },
  computed: {
  },
  watch: {
    $route(to, from) {
      if (from.name === 'user') {
        location.reload();
      }
    },
    'bindData.smsCode'(val) {
      if (val.length > 0) {
        this.btnShow = false;
      } else {
        this.btnShow = true;
      }
    }
  },
  created() {
    this.getImg();
  },
  methods: {
    OnBind() {
      // inviteId 先获取邀请函信息 然后绑定账号 跳回二维码页面
      if (!this.bindData.smsCode) {
        this.codeError = true;
        return;
      } else {
        this.codeError = false;
      }
      if (this.checkPhone()) {
        const data = { phone: this.bindData.phone, id: this.$route.query.inviteId };
        inviteInfo(data).then(res => {
          if (res.code === 200) {
            const { name } = res.data;
            this.bindData.name = name;
            this.bindData.gender = 'MALE';
            onBind(this.bindData).then(res => {
              this.$toast.success({
                icon: 'checked',
                message: '绑定成功',
                mask: true,
                className: 'newToast'
              });
              const data = {};
              GetUserInfo(data).then(response => {
                if (response.data) {
                  this.personalInfo = response.data;
                  localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                  this.$router.push({ path: '/qrcode', query: { id: this.$route.query.inviteId }});
                }
              });
            });
          }
        });
      }
    },
    getImg() {
      getCaptcha({}).then(res => {
        this.captchaInfo = res.data;
        this.bindData.uuid = res.data.uuid;
      });
    },
    // 校验手机号
    checkPhone() {
      let phone;
      if (this.bindData.phone == '') {
        phone = false;
        this.phonErrMsg = '请输入手机号';
      } else if (!(/^1[3456789]\d{9}$/.test(this.bindData.phone))) {
        this.phonErrMsg = '手机号格式错误，请检查';
        phone = false;
      } else {
        this.phonErrMsg = '';
        phone = true;
      }
      return phone;
    },
    checkCode() {
      let code;
      if (this.bindData.smsCode.length > 6) this.bindData.smsCode = this.bindData.smsCode.slice(0, 6);
      if (this.bindData.smsCode.length !== 6) {
        code = false;
        this.codeErrMsg = '请输入六位数验证码';
      } else {
        this.codeErrMsg = '';
        code = true;
      }
      return code;
    },
    GetCode() {
      // 函数节流
      if (!this.checkPhone()) {
        return;
      }
      if (!this.bindData.captchaResult && this.captchaInfo.open) {
        this.getImg();
        this.visible = true;
        return;
      }
      if (!this.codeFlag) return;
      this.codeFlag = false;
      // 修改按钮名称
      this.btnName = '发送中...';
      const data = { phone: this.bindData.phone };
      if (this.captchaInfo.open) {
        data.captchaUuid = this.bindData.uuid;
        data.captchaResult = this.bindData.captchaResult;
      }
      getCode(data).then(res => {
        if (res.code === 200) {
          // 发送成功
          let _time = this.countDown;
          this.codeInterval = setInterval(() => {
            _time -= 1;
            this.btnName = _time.toString() + '秒后重新获取';
            if (_time <= 0) {
              clearInterval(this.codeInterval);
              // 修改按钮名称
              this.btnName = this.btnDefault;
              this.bindData.captchaResult = '';
              // 恢复函数节流
              this.codeFlag = true;
            }
          }, 1000);
        }
      }).catch(err => {
        console.log(err);
        this.bindData.captchaResult = null;
        this.btnName = '获取验证码';
        this.codeFlag = true;
      });
    },
    beforeClose(action, done) {
      const that = this;
      if (action === 'confirm') {
        if (!this.bindData.captchaResult) {
          Toast.fail({
            icon: 'warning',
            message: '请输入',
            mask: true,
            className: 'newToast'
          });
          return;
        }
        done();
        that.GetCode();
      } else if (action === 'cancel') {
        done(); // 关闭
        that.bindData.captchaResult = null;
      }
    }
  }

};
</script>

<style lang="less" >
@import './styles/bind.less';
</style>
